// src/components/experts/AboutVision.jsx
import React from 'react';

const AboutVision = () => {
  return (
    <section className="py-8 mb-8 bg-white rounded-lg shadow-md p-8">
      <h2 className="text-2xl font-bold text-gray-800 mb-6 text-center">Our Vision</h2>
      <p className="text-lg text-gray-700 leading-relaxed mb-4">
        Our vision is to empower aspiring medical professionals with the knowledge, skills, and confidence they need to excel in their examinations and make a meaningful impact in healthcare. We strive to create a supportive and innovative learning environment that fosters collaboration, critical thinking, and a lifelong passion for medicine.
      </p>
      <p className="text-gray-700 leading-relaxed">
        We believe in the power of expert guidance and personalized learning pathways. By connecting students with experienced educators and providing comprehensive resources, we aim to bridge the gap between aspiration and achievement. Our commitment extends beyond exam preparation to nurturing well-rounded individuals who are prepared to meet the challenges of the medical field with compassion and competence.
      </p>
    </section>
  );
};

export default AboutVision;